import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=54ecf5cc&scoped=true&"
import script from "./invoice.vue?vue&type=script&lang=js&"
export * from "./invoice.vue?vue&type=script&lang=js&"
import style0 from "./invoice.vue?vue&type=style&index=0&id=54ecf5cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ecf5cc",
  null
  
)

export default component.exports